import { LoadingCard } from '@/components/Base/LoadingCard/LoadingCard'
import { NoDataToDisplayCard } from '@/components/Base/NoDataToDisplayCard/NoDataToDisplayCard'
import StaticReportsList from '@/components/StaticReportsList/StaticReportsList'
import { useAppDispatch } from '@/hooks/use-app-dispatch'
import { useAppSelector } from '@/hooks/use-app-selector'
import { IReportDTO } from '@/interfaces/report.interface'
import StaticReportsLayout from '@/Layouts/StaticReportsLayout'
import { fetchAllReportsAsync } from '@/states/axiomReport.slice'
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model'
import { ModuleRegistry } from '@ag-grid-community/core'
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel'
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel'
import { MenuModule } from '@ag-grid-enterprise/menu'

import { ModuleTypePageTitle } from '@/enums/axiom-report.enum'
import { Box, Card, CardContent, CardHeader } from '@mui/material'
import React, { useEffect, useState } from 'react'

ModuleRegistry.registerModules([
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MenuModule,
  ClientSideRowModelModule,
])
const StaticReportsPage: React.FC = () => {
  const dispatch = useAppDispatch()
  const allReportsSummary = useAppSelector(
    (s) => s.axiomReport.allReportsSummary,
  )
  const showLoader = useAppSelector((s) => s.axiomReport.showLoader)
  const [allReportDataList, setAllReportDataList] = useState<IReportDTO[]>([])

  useEffect(() => {
    dispatch(fetchAllReportsAsync())
  }, [dispatch])

  useEffect(() => {
    setAllReportDataList(allReportsSummary)
  }, [allReportsSummary])

  return (
    <StaticReportsLayout title={ModuleTypePageTitle.REPORTING}>
      <Box display='grid' gridTemplateRows='1fr' gap={4}>
        <Card>
          <CardHeader title='Report Library' sx={{ pb: 0 }} />
          <CardContent sx={{ height: 'calc(100% - 2.5rem)' }}>
            {showLoader && <LoadingCard />}
            {!showLoader && !allReportDataList.length && (
              <NoDataToDisplayCard />
            )}
            {!showLoader && allReportDataList.length ? (
              <StaticReportsList rowData={allReportDataList} />
            ) : (
              <></>
            )}
          </CardContent>
        </Card>
      </Box>
    </StaticReportsLayout>
  )
}

export default StaticReportsPage
